import {
    deleteCostProviderLoading,
    deleteCostProviderRequest,
    deleteCostProviderSuccess,
    deleteCostProviderReject,
    deleteCostProviderReset
} from "../../actions/costProvider/delete";

export const deleteCostProvider = (formData) => async (dispatch, getState) => {
    dispatch(deleteCostProviderLoading());
    try {
        const { data } = await deleteCostProviderRequest(getState, formData);
        dispatch(deleteCostProviderSuccess(data))
    } catch (error) {
        dispatch(deleteCostProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteCostProviderReset()) }, 3000);
    }
    return Promise.resolve();
};